// extracted by mini-css-extract-plugin
export var content = "MediaEntry-module--content--db9ef";
export var credit = "MediaEntry-module--credit--a22ab";
export var image = "MediaEntry-module--image--d03d8";
export var imageContainer = "MediaEntry-module--imageContainer--0e7e8";
export var link = "MediaEntry-module--link--03681";
export var root = "MediaEntry-module--root--c2520";
export var title = "MediaEntry-module--title--12fe4";
export var titleLink = "MediaEntry-module--titleLink--f63d4";